import { readTextFile } from '../utils/readJson.js'
import { createAndAddGenericElement, getFormattedText, getClassList } from './generics.js'

const addParaText = (para, parentElem) => {
    if (para.text) {
        const isBold = (para.bold) ? true : false
        parentElem.innerHTML = getFormattedText(para.text, isBold)
    } else if (para.textList) {
        const paraDiv = createAndAddGenericElement(para.classList, "", "", "", para.element)
        for (let i = 0; i < para.textList.length; ++i) {
            const isBold = (para.bold) ? true : false
            createAndAddGenericElement([""], "", paraDiv, para.textList[i], 'div', isBold)
        }
        parentElem.appendChild(paraDiv)
    } else if (para.items) {
        const ul = createAndAddGenericElement([""], "", "", "", para.element)
        for (let j = 0; j < para.items.length; ++j) {
            const li = createAndAddGenericElement([""], "", "", "", "li")     // create li
            const i = createAndAddGenericElement(["fa", "fa-check", "mr-2"], "", "", "", "i")     // create li
            i.setAttribute('aria-hidden', true)
            const span = createAndAddGenericElement([""], "", "", para.items[j], "span")
            i.appendChild(span)
            li.appendChild(i)
            ul.appendChild(li)
        }
        parentElem.appendChild(ul)
    }
}

const createHeader = (aboutUsData, aboutUsSection) => {
    const headingFaq = createAndAddGenericElement(["text-center", "mt-5", "mb-5", "custom-underline"], "", "", aboutUsData.aboutUs.aboutUsHeading, aboutUsData.aboutUs.element)
    createAndAddGenericElement(["boxUnderline"], headingFaq, aboutUsSection, "", "div")
}

const createLevelElements = (parentId, levelJson) => {
    for (let i = 0; i < levelJson.length; ++i) {
        const level = levelJson[i]
        const htmlElement = createAndAddGenericElement(getClassList(level), "", "", "", level.element)
        addParaText(level, htmlElement)
        parentId.appendChild(htmlElement)
    }
}

const populateAboutUsSection = (aboutUsSection, levelIdList, jsonFile) => {
    readTextFile(jsonFile, function (readText) {
        const aboutUsData = JSON.parse(readText)
        createHeader(aboutUsData, aboutUsSection)

        for (let i = 0; i < levelIdList.length; ++i) {
            createLevelElements(levelIdList[i], aboutUsData.aboutUsList[i].level)
        }
    })
}
export { populateAboutUsSection }